import styled from "@emotion/styled";

//Only for representing the container in production
export const CalendarWrapper = styled.div`
    max-width: 1057px;
`;

export const CalendarCard = styled.div`
    display: flex;
    height: 100%;
    background-color: white;
    border-radius: 20px;
    @media screen and (max-width: 991px) {
        flex-direction: column;
        align-items: center;
    }
`;
